import {percent, px} from '@packages/systems/core/utils/WebflowCssSubset';
import View from '../View';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const config = createIntegratedAtom({
  displayName: 'Column',
  showEmpty: true,
  style: {
    base: {
      main: {
        noPseudo: {
          paddingRight: px(8),
          paddingLeft: px(8),
          flexGrow: 1,
          flexShrink: 1,
          flexBasis: percent(0),
        },
      },
    },
  },
  render: View,
  fields: {children: TListOfElement},
});

export default config;
